import {
  panoramaClient,
  type PanoramaClientFactory,
  type PluginParams,
} from '@wix/panorama-client';
import type {
  EventPayload,
  BaseParams,
  UserParams,
} from '@wix/panorama-common-shared/types';
import { CLICKHOUSE_REPORT_URL } from '@wix/panorama-common-shared/constants';
import { nodeReporter } from './reporter';
import type { ReporterOptions } from './types';

interface FactoryOptions {
  baseParams?: BaseParams;
  data?: UserParams['data'];
  pluginParams?: PluginParams;
  reporterOptions?: ReporterOptions;
}

export type Factory = Omit<PanoramaClientFactory, 'use'>;

export const panoramaClientFactory = (options: FactoryOptions): Factory => {
  const { baseParams, reporterOptions, data } = options;

  const factory = panoramaClient<EventPayload>({
    baseParams,
    data,
  }).withReporter(nodeReporter(CLICKHOUSE_REPORT_URL, reporterOptions));

  // @ts-expect-error
  factory.use = undefined;

  return factory;
};
